import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../../asstes/styles/PortfolioCollapse.scss";
import { Row, Col } from "react-bootstrap";

gsap.registerPlugin(ScrollTrigger);

const cards = [
    {
        id: 1,
        img: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1200",
        x: -700,
        y: -250,
        rotate: -12,
    },
    {
        id: 2,
        img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200",
        x: 650,
        y: -250,
        rotate: 10,
    },
    {
        id: 3,
        img: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200",
        x: -550,
        y: 250,
        rotate: 8,
    },
    {
        id: 4,
        img: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200",
        x: 600,
        y: 250,
        rotate: -8,
    },
    {
        id: 5,
        img: "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?w=1200",
        x: 0,
        y: -420,
        rotate: -5,
    },
    {
        id: 6,
        img: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=1200",
        x: 0,
        y: 420,
        rotate: 5,
    },
    {
        id: 7,
        img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200",
        x: -900,
        y: 0,
        rotate: -15,
    },
    {
        id: 8,
        img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1200",
        x: 900,
        y: 0,
        rotate: 15,
    },
];

export default function PortfolioCollapse() {
    const sectionRef = useRef();

    useEffect(() => {
        const ctx = gsap.context(() => {
            gsap.to(".floating-card", {
                y: "+=20",
                duration: 3,
                repeat: -1,
                yoyo: true,
                stagger: 0.15,
                ease: "sine.inOut",
            });

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top top",
                    end: "+=3000",
                    scrub: 1,
                    pin: true,
                },
            });

            tl.to(
                ".floating-card",
                {
                    x: 0,
                    y: 0,
                    rotation: 0,
                    scale: 0.2,
                    opacity: 0,
                    filter: "blur(10px)",
                    stagger: 0.04,
                    ease: "power4.out",
                },
                0
            );

            tl.to(
                ".portfolio-collapse-box",
                {
                    width: "85vw",
                    height: "80vh",
                    borderRadius: "32px",
                    ease: "power4.out",
                },
                0.3
            );

            tl.to(
                ".portfolio-collapse-content",
                {
                    opacity: 1,
                    y: 0,
                    duration: 1,
                },
                0.8
            );
        }, sectionRef);

        return () => ctx.revert();
    }, []);

    return (
        <section className="portfolio-collapse" ref={sectionRef}>
            <div className="sticky-wrapper pd-common">
                <div className="floating-layer">
                    {cards.map((card) => (
                        <div
                            key={card.id}
                            className="floating-card"
                            style={{
                                transform: `translate(${card.x}px, ${card.y}px) rotate(${card.rotate}deg)`,
                            }}
                        >
                            <img src={card.img} alt="" />
                        </div>
                    ))}
                </div>
                
                        <div className="portfolio-collapse-box">

                            <img
                                className="portfolio-collapse-bg"
                                src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=2000"
                                alt=""
                            />
                            <div className="portfolio-collapse-overlay"></div>
                            <div className="portfolio-collapse-content">

                                <div className="widget-title-sec">
                                    <h2 className="widget-title">The Decision You <span className="fs-secondary">Can't Avoid</span></h2>
                                    <h3 className="widget-subtitle">Dr.Bhupendra Chaudhary has been sought in rare moments when a person’s direction is already known, and what remains is choosing without retreat.</h3>
                                    <p>The Private Council is a unique, singular engagement for those who already know what they must do — and have become ready to carry it.
                                    </p>
                                </div>
                                <div className="widget-btn-toolbar">
                                    <a href="/alignment-review" className="widget-text-icon-btn">
                                        Request Private Alignment Review
                                        <i className="bi bi-arrow-right"></i>
                                    </a>
                                </div>

                            </div>

                        </div> 

            </div>
        </section>
    );
}